import { render, staticRenderFns } from "./InputClients.vue?vue&type=template&id=763daed4"
import script from "./InputClients.vue?vue&type=script&lang=js"
export * from "./InputClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports